// extracted by mini-css-extract-plugin
module.exports = {"spam-content":"report_spam-content__ZcxbH","header":"report_header__EL4b8","spam":"report_spam__pxHSO","is-reported":"report_is-reported__2iPRt"};